export default "__VITE_ASSET__CrjvVYDD__"